import { ColumnsType } from "antd/es/table";
import AntTable from "../../../components/table/Table";
import {
    EditOutlined
} from "@ant-design/icons";
import { Avatar, Button, Flex, Modal, Space, Tag, notification } from "antd";
import { useState } from "react";
import CreateAffiliate from "./../Member/CreateAffiliate";
import { AffiliateService } from "../../../services/AffiliateService";
import EditMember from "./../../member/EditMember";

export default function Affiliate() {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [editRecord, setEditRecord] = useState<object>()
    const [refreshData, setRefreshData] = useState<boolean>(false)
    const [isModalOpenUser, setIsModalOpenUser] = useState<boolean>(false);
    const [editRecordUser, setEditRecordUser] = useState<{
        id: number
    }>()

    const [columns] = useState<ColumnsType<any>>([
        {
            title: 'User Id',
            align: 'center',
            dataIndex: 'user_id',
            key: 'user_id',
            render: (value, record) => {
                return <div
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => {
                        setEditRecordUser({
                            id: record?.user_id
                        })
                        setIsModalOpenUser(true)
                    }}>{value}</div>
            },
        },
        {
            title: 'Top Agent Name',
            align: 'center',
            dataIndex: 'topAgent',
            key: 'topAgent',
            render: (value, record) => {
                if(!value?.id){
                    return null;
                }

                return <div
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    onClick={() => {
                        setEditRecordUser({
                            id: value?.id
                        })
                        setIsModalOpenUser(true)
                    }}>{value?.full_name}</div>
            },
        },
        {
            title: 'Company Name',
            align: 'center',
            dataIndex: 'company_name',
            key: 'company_name',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Email',
            align: 'center',
            dataIndex: 'email',
            key: 'email',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Tel',
            align: 'center',
            dataIndex: 'tel',
            key: 'tel',
            render: (value, record) => {
                return value
            },
        },
        {
            title: 'Status',
            align: 'center',
            dataIndex: 'status',
            key: 'status',
            sorter: true,
            render: (value, record) => {

                switch (value) {
                    case 'CANCELLED':
                        return <Tag color={"red"} >{value}</Tag>
                    case 'PROGRESS':
                        return <Tag color={"gray"} >{value}</Tag>
                    case 'ACTIVE':
                        return <Tag color={"green"} >{value}</Tag>
                    default:
                        break;
                }

            },
        },
        {
            title: 'Agent Type',
            align: 'center',
            filters: [
                {
                    text: 'Top Agent',
                    value: "1",
                },
                {
                    text: 'Agent',
                    value: "0",
                }
            ],
            dataIndex: 'is_top_agent',
            key: 'is_top_agent',
            sorter: true,
            render: (is_top_agent, record) => {
                if (is_top_agent == 1) {
                    return <Tag color={"green"} >Top Agent</Tag>
                } else if (is_top_agent == 0 && record?.top_agent_id) {
                    return <Tag color={"gray"} >Sub Agent</Tag>;
                } else {
                    return null;
                }
            },
        },

        {
            title: '',
            align: 'center',
            width: 180,
            dataIndex: 'created_at',
            key: 'created_at',
            render: (text, record: any) => {
                return (
                    <Flex gap="small" wrap="wrap">
                        {
                            record?.status != 'ACTIVE' ?
                                <div onClick={() => onStatusChange(record.id, 'approve')} >
                                    <Button type={'primary'} size="small" >Approve</Button>
                                </div>
                                :
                                null
                        }

                        {
                            record?.status != 'PROGRESS' ?
                                <div onClick={() => onStatusChange(record.id, 'progress')} >
                                    <Button type={'default'} size="small"  >Progress</Button>
                                </div>
                                :
                                null
                        }


                        {
                            record?.status != 'CANCELLED' ?
                                <div onClick={() => onStatusChange(record.id, 'reject')} >
                                    <Button type={'primary'} size="small" danger >Reject</Button>
                                </div>
                                :
                                null
                        }



                    </Flex>
                )
            }
        },
        {
            title: 'Actions',
            align: 'center',
            dataIndex: 'actions',
            key: 'created_at',
            render: (text, record: any) => {

                if (record?.status != 'CANCELLED') {
                    return (
                        <Flex gap="small" justify="center" wrap="wrap">
                            <span onClick={() => {
                                setIsModalOpen(true)
                                setEditRecord(record)
                            }} >
                                <Button type="primary" icon={<EditOutlined></EditOutlined>}></Button>
                            </span>
                        </Flex>
                    )
                } else {
                    return <></>
                }


            }
        }
    ])

    const onLoadData = async (params: any = {}) => {
        const payload = {
            ...params,
        }
        const res = await AffiliateService.getAffiliateMembers(payload)
        return res
    }

    const onStatusChange = async (id: number, status: 'approve' | 'progress' | 'reject') => {

        const data = {
            id: id,
            status: status
        }
        const res = await AffiliateService.changeStatus(data)

        if (res.status == 1) {
            notification.open({
                type: 'success',
                message: res.status_detail,
                placement: 'top'
            });
            setRefreshData(p => !p)
        } else {
            notification.open({
                type: 'error',
                message: res.status_detail,
                placement: 'top'
            });
        }
    }



    return (
        <>
            <Modal
                title=""
                width={900}
                open={isModalOpen}
                onOk={() => setIsModalOpen(true)}
                onCancel={() => setIsModalOpen(false)}
                footer={null}>
                <CreateAffiliate
                    record={editRecord}
                    onFinish={() => {
                        setIsModalOpen(false)
                        setRefreshData(p => !p)
                    }}
                ></CreateAffiliate>
            </Modal>
            <Modal
                title=""
                width={900}
                open={isModalOpenUser}
                onOk={() => setIsModalOpenUser(true)}
                onCancel={() => setIsModalOpenUser(false)}
                footer={null}>
                <EditMember
                    record={editRecordUser}
                    onFinish={() => {
                        setIsModalOpenUser(false)
                    }}
                ></EditMember>
            </Modal>
            <AntTable
                refresh={refreshData}
                menuOptions={false}
                search
                title="Affiliate Members"
                columns={columns}
                onLoadData={onLoadData}
            />
        </>
    )
}
